import { configureStore } from "@reduxjs/toolkit";

// environment
import env from "../config/env";

// store
import auth from "./slices/auth";
import message from "./slices/message";
import message2 from "./slices/message2";
import loading from "./slices/loading";
import order from "./slices/order";
import misc from "./slices/misc";
import contact_us from "./slices/contact_us";
import assessmentSlice from "./slices/assessment";

export const store = configureStore({
  reducer: {
    auth,
    message,
    message2,
    loading,
    order,
    misc,
    contact_us,
    assessmentSlice,
  },
  devTools: env.enviroment === "production" ? false : true,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
